var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "s3-browser" }, [
    _c("div", { staticClass: "file-panel" }, [
      _c(
        "ul",
        { staticClass: "file-list" },
        _vm._l(_vm.files, function (file, idx) {
          return _c(
            "li",
            {
              key: idx,
              class: { active: _vm.selectedKey === file },
              on: {
                click: function ($event) {
                  return _vm.selectFile(file)
                },
              },
            },
            [
              _vm._v(
                "\n                📄 " +
                  _vm._s(_vm.fileName(file)) +
                  "\n            "
              ),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "preview-panel" }, [
      _vm.error
        ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "loading" }, [_vm._v("Loading preview...")])
        : _vm._e(),
      _vm._v(" "),
      _vm.previewUrl && !_vm.loading
        ? _c("div", { staticClass: "preview" }, [
            _vm.previewType === "image"
              ? _c("img", {
                  staticClass: "preview-image",
                  attrs: { src: _vm.previewUrl },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.previewType === "pdf"
              ? _c("iframe", {
                  staticClass: "preview-pdf",
                  attrs: { src: _vm.previewUrl },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.previewType === "other"
              ? _c("div", [_c("p", [_vm._v("No inline preview available.")])])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "preview-actions" }, [
              _c("button", { on: { click: _vm.downloadFile } }, [
                _vm._v("Download"),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.previewUrl && !_vm.loading && !_vm.error
        ? _c("div", { staticClass: "no-selection" }, [
            _vm._v("\n            Click a file to preview\n        "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }